import React from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';

const Widget = ({ children, titleKey, columns, address, ...rest }) => {
  const { t } = useTranslation('account');
  return (
    <>
      <h3 className="widget-title">{t(titleKey)}</h3>
      <div className={`widget-content ${address ? 'address' : ''} ${columns === 2 ? 'two-columns' : ''}`} {...rest}>
        {children}
      </div>
    </>
  );
};

export default Widget;
